import BuildingFilter from './building-filter'

export default BuildingFilter
